import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Modal } from "antd";
import React, { useEffect, useState } from "react";
import DebtorSelect from "../debtors/DebtorSelect";
import CustomerResource from "./api/CustomerResource";
import { axiosErrorHandler } from "../../../../swzutils";
const CustomerDebtorModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    useEffect(() => {
        form.resetFields();
    }, [open]);
    const onFinish = (formValues) => {
        setLoading(true);
        CustomerResource.linkDebtor(props.customer.id, formValues.debtorId, props.onSuccess, axiosErrorHandler, () => setLoading(false));
    };
    return (_jsx(Modal, { title: "Select a Debtor", open: props.open, onOk: () => form.submit(), onCancel: props.onCancel, confirmLoading: loading, children: _jsx(Form, { layout: "vertical", form: form, onFinish: onFinish, children: _jsx(Form.Item, { label: "Debtor", name: "debtorId", children: _jsx(DebtorSelect, {}) }) }) }));
};
export default CustomerDebtorModal;
